import {useState} from 'react';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import {useTranslation} from 'next-i18next';
import LandingDataProtectionSection from '../../components/landing/LandingDataProtectionSection';
import {MainTitle, LandingBigSecondaryButton} from '../landingStyledComponents';
import {WidthContainer} from '../landing/LandingComponents';
import {Container} from '../landing/LandingHeroSection';
import RemixIcon from '../RemixIcon';

const ReactPlayer = dynamic(() => import('react-player/file'), {ssr: false});

const compactThreshold = 900;
const mobileThreshold = 600;

const DataProtectionContainer = styled(Container)`
  height: initial;
  max-height: initial;
  min-height: initial;
`;

const StyledWidthContainer = styled(WidthContainer)`
  display: flex;
  flex-direction: column;
  margin-top: 120px;
  padding-bottom: 20px;
  align-items: center;

  @media (max-width: ${compactThreshold}px) {
    padding: 0 var(--side-padding);
    margin-top: 40px;
  }

  @media (max-height: 800px) {
    margin-top: 40px;
  }

  .data-protection-strip {
    @media (max-width: 1000px) {
      margin: 50px auto;
    }

    @media (max-width: 700px) {
      margin: 50px auto 30px auto;
    }
  }
`;

const HeroTitle = styled(MainTitle)`
  text-align: center;
  max-width: 900px;

  @media (max-width: ${mobileThreshold}px) {
    text-align: left;
  }
`;

const Description = styled.p`
  font-size: 20px;
  text-align: center;
  margin: 30px 0;
  max-width: 650px;

  @media (max-width: ${mobileThreshold}px) {
    text-align: left;
    margin: 20px 0;
    font-size: 16px;
  }
`;

const VideoContainer = styled.div`
  background-color: white;
  border-radius: 24px;
  width: 100%;
  max-width: 1170px;
  margin-top: 30px;
  flex-grow: 1;
  z-index: 1;
  box-shadow: 0px 14px 54px 0 rgba(21, 134, 140, 0.2);
  margin-bottom: 80px;
  position: relative;
  overflow: hidden;

  @media (max-width: ${compactThreshold}px) {
    margin-top: 40px;
  }

  @media (max-width: ${mobileThreshold}px) {
    margin: 30px 0 50px 0;
  }
`;

const AspectRatioWrapper = styled.div`
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
`;

const PlayerAndStripContainer = styled.div`
  width: 100%;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 700px) {
    flex-direction: column-reverse;
  }
`;

const DataProtectionHeroSection = () => {
  const {t} = useTranslation();
  const [isVideoShown, setIsVideoShown] = useState(false);

  return (
    <DataProtectionContainer>
      <StyledWidthContainer>
        <div className="flex flex-col items-center grow mb-6">
          <HeroTitle>{t('website.privacy page hero title')}</HeroTitle>
          <Description>{t('website.privacy page subheading')}</Description>
        </div>

        {isVideoShown ? (
          <VideoContainer>
            <AspectRatioWrapper>
              <ReactPlayer
                url="https://panelista.s3.nl-ams.scw.cloud/website/data-protection-video/playlist.m3u8"
                height="100%"
                width="100%"
                playsinline
                config={{attributes: {poster: '/images/dpa-video-poster.jpg'}}}
                style={{position: 'absolute'}}
                controls
              />
            </AspectRatioWrapper>
          </VideoContainer>
        ) : (
          <LandingBigSecondaryButton as="button" onClick={() => setIsVideoShown(true)} style={{textAlign: 'left'}}>
            <RemixIcon name="play-line" color="var(--panelista-color)" className="-ml-2 mr-4" />
            En introduktion till Panelista på fem minuter
          </LandingBigSecondaryButton>
        )}

        <PlayerAndStripContainer>
          <LandingDataProtectionSection />
        </PlayerAndStripContainer>
      </StyledWidthContainer>
    </DataProtectionContainer>
  );
};

export default DataProtectionHeroSection;
